var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 355,
    height: 513,
    viewBox: "0 0 355 513",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1702_701322)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1702_701322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.0001 140.818C75.978 153.525 84.0174 164.78 95.8666 168.629C107.715 172.479 120.637 168.034 127.798 157.647C134.959 147.259 134.705 133.326 127.171 123.218L117.912 97.9825L91.0884 97.9825L81.8285 123.218C78.0465 128.271 75.9984 134.457 76.0001 140.818V140.818Z",
    fill: "#CCD8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 151.01C91 151.838 90.3284 152.51 89.5 152.51V152.51C88.6716 152.51 88 151.838 88 151.01L88 150.924C88 150.095 88.6716 149.424 89.5 149.424V149.424C90.3284 149.424 91 150.095 91 150.924L91 151.01Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 144.837C96 145.666 95.3284 146.337 94.5 146.337V146.337C93.6716 146.337 93 145.666 93 144.837L93 143.722C93 142.893 93.6716 142.222 94.5 142.222V142.222C95.3284 142.222 96 142.893 96 143.722L96 144.837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5443 97H121.456L133 137H76L87.5443 97Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.765 96.4983C122.765 97.6029 121.869 98.4983 120.765 98.4983L89.0004 98.4983C87.8958 98.4983 87.0004 97.6029 87.0004 96.4983L87.0004 75.5346C87.0004 74.43 87.8958 73.5346 89.0004 73.5346L120.765 73.5346C121.869 73.5346 122.765 74.43 122.765 75.5346L122.765 96.4983Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.803 67.5016L113.96 67.5016C117.303 67.5016 120.013 70.3765 120.013 73.9224L89.7506 73.9224C89.7506 70.3765 92.4599 67.5016 95.803 67.5016Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 94.3198L106.5 94.3198L106.5 91.2913L123 91.2913L123 94.3198Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 86.7484L87.0002 86.7484L87.0002 80.6913L123 80.6913L123 86.7484Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.839 101.824C102.93 100.792 103.795 100 104.831 100H105.169C106.205 100 107.07 100.792 107.161 101.824L109.808 131.824C109.911 132.994 108.99 134 107.816 134H102.184C101.01 134 100.089 132.994 100.192 131.824L102.839 101.824Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.061 102.059C111.027 100.932 111.932 100 113.06 100H113.322C114.293 100 115.123 100.697 115.292 101.652L120.586 131.652C120.802 132.877 119.86 134 118.616 134H113.942C112.86 134 111.975 133.14 111.943 132.059L111.061 102.059Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.262 101.783C118.124 100.843 118.852 100 119.802 100V100C120.508 100 121.126 100.475 121.307 101.158L129.335 131.488C129.671 132.757 128.714 134 127.402 134H124.727C123.735 134 122.893 133.273 122.749 132.291L118.262 101.783Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7084 101.652C94.8771 100.697 95.7075 100 96.678 100H96.9403C98.0679 100 98.9726 100.932 98.9394 102.059L98.0571 132.059C98.0253 133.14 97.1396 134 96.058 134H91.3838C90.1402 134 89.1982 132.877 89.4143 131.652L94.7084 101.652Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6881 101.178C87.8719 100.484 88.5005 100 89.219 100V100C90.167 100 90.9027 100.827 90.7919 101.769L87.2078 132.234C87.0893 133.241 86.2357 134 85.2215 134H81.5983C80.2857 134 79.329 132.757 79.6649 131.488L87.6881 101.178Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: -276,
    width: 4,
    height: 344,
    fill: "#F7F7F7"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1702_701322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221 140.818C220.978 153.525 229.017 164.78 240.867 168.629C252.715 172.479 265.637 168.034 272.798 157.647C279.959 147.259 279.705 133.326 272.171 123.218L262.912 97.9825L236.088 97.9825L226.828 123.218C223.047 128.271 220.998 134.457 221 140.818V140.818Z",
    fill: "#CCD8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236 151.01C236 151.838 235.328 152.51 234.5 152.51V152.51C233.672 152.51 233 151.838 233 151.01L233 150.924C233 150.095 233.672 149.424 234.5 149.424V149.424C235.328 149.424 236 150.095 236 150.924L236 151.01Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241 144.837C241 145.666 240.328 146.337 239.5 146.337V146.337C238.672 146.337 238 145.666 238 144.837L238 143.722C238 142.893 238.672 142.222 239.5 142.222V142.222C240.328 142.222 241 142.893 241 143.722L241 144.837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.544 97H266.456L278 137H221L232.544 97Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.765 96.4983C267.765 97.6029 266.869 98.4983 265.765 98.4983L234 98.4983C232.896 98.4983 232 97.6029 232 96.4983L232 75.5346C232 74.43 232.896 73.5346 234 73.5346L265.765 73.5346C266.869 73.5346 267.765 74.43 267.765 75.5346L267.765 96.4983Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.803 67.5016L258.96 67.5016C262.303 67.5016 265.013 70.3765 265.013 73.9224L234.751 73.9224C234.751 70.3765 237.46 67.5016 240.803 67.5016Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268 94.3198L251.5 94.3198L251.5 91.2913L268 91.2913L268 94.3198Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268 86.7484L232 86.7484L232 80.6913L268 80.6913L268 86.7484Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.839 101.824C247.93 100.792 248.795 100 249.831 100H250.169C251.205 100 252.07 100.792 252.161 101.824L254.808 131.824C254.911 132.994 253.99 134 252.816 134H247.184C246.01 134 245.089 132.994 245.192 131.824L247.839 101.824Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.061 102.059C256.027 100.932 256.932 100 258.06 100H258.322C259.293 100 260.123 100.697 260.292 101.652L265.586 131.652C265.802 132.877 264.86 134 263.616 134H258.942C257.86 134 256.975 133.14 256.943 132.059L256.061 102.059Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.262 101.783C263.124 100.843 263.852 100 264.802 100V100C265.508 100 266.126 100.475 266.307 101.158L274.335 131.488C274.671 132.757 273.714 134 272.402 134H269.727C268.735 134 267.893 133.273 267.749 132.291L263.262 101.783Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.708 101.652C239.877 100.697 240.707 100 241.678 100H241.94C243.068 100 243.973 100.932 243.939 102.059L243.057 132.059C243.025 133.14 242.14 134 241.058 134H236.384C235.14 134 234.198 132.877 234.414 131.652L239.708 101.652Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.688 101.178C232.872 100.484 233.5 100 234.219 100V100C235.167 100 235.903 100.827 235.792 101.769L232.208 132.234C232.089 133.241 231.236 134 230.222 134H226.598C225.286 134 224.329 132.757 224.665 131.488L232.688 101.178Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: -276,
    width: 4,
    height: 344,
    fill: "#F7F7F7"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 159,
    y: 58,
    width: 42,
    height: 61,
    rx: 2,
    fill: "#668BA6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169,
    y: 68,
    width: 22,
    height: 41,
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169 68L172 67V87L181 105L169 109V68Z",
    fill: "#CCD8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 105H201L191 109H169L179 105Z",
    fill: "#BACAD6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 67,
    width: 22,
    height: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172 87H194L201 105H179L172 87Z",
    fill: "#F5F7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.551 79.12C180.381 79.12 181.251 78.23 181.251 76.38V74.82C181.251 72.97 180.381 72.08 178.551 72.08C176.731 72.08 175.861 72.97 175.861 74.82V76.38C175.861 78.23 176.731 79.12 178.551 79.12ZM178.551 78.05C177.511 78.05 177.081 77.54 177.081 76.37V74.83C177.081 73.66 177.511 73.15 178.551 73.15C179.591 73.15 180.031 73.66 180.031 74.83V76.37C180.031 77.54 179.591 78.05 178.551 78.05ZM184.644 72.65H185.274V71.7H184.284C183.284 71.7 182.804 72.24 182.804 73.36V73.81H181.934V74.74H182.804V79H184.004V74.74H185.234V73.81H184.004V73.38C184.004 72.85 184.174 72.65 184.644 72.65ZM188.033 72.65H188.663V71.7H187.673C186.673 71.7 186.193 72.24 186.193 73.36V73.81H185.323V74.74H186.193V79H187.393V74.74H188.623V73.81H187.393V73.38C187.393 72.85 187.563 72.65 188.033 72.65Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.961 97.3658C186.791 97.3658 187.324 96.5421 186.623 94.83L186.032 93.3863C185.331 91.6741 184.124 90.8505 182.294 90.8505C180.474 90.8505 179.941 91.6741 180.642 93.3863L181.233 94.83C181.934 96.5421 183.141 97.3658 184.961 97.3658ZM184.555 96.3755C183.515 96.3755 182.892 95.9036 182.449 94.8207L181.866 93.3955C181.422 92.3127 181.659 91.8407 182.699 91.8407C183.739 91.8407 184.372 92.3127 184.816 93.3955L185.399 94.8207C185.842 95.9036 185.595 96.3755 184.555 96.3755ZM189.606 92.3405C188.926 92.3405 188.511 92.5718 188.311 93.1086L188.002 92.4515H186.982L188.948 97.2547H190.148L188.871 94.1359C188.938 93.5899 189.208 93.3215 189.708 93.3215C190.198 93.3215 190.548 93.5899 190.79 94.1822L192.048 97.2547H193.248L191.948 94.0804C191.479 92.9328 190.686 92.3405 189.606 92.3405Z",
    fill: "#3A3A3A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1702_701322"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 355,
    height: 513,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1702_701322"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 210,
    height: 425,
    fill: "white",
    transform: "translate(0 -149)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1702_701322"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 210,
    height: 425,
    fill: "white",
    transform: "translate(145 -149)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightOff);
export default __webpack_public_path__ + "static/media/LightOff.95efef1a02af4b6111cfa50b1a72a369.svg";
export { ForwardRef as ReactComponent };